import {createApp} from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import {globalCookiesConfig} from 'vue3-cookies'
import i18n from '@/i18n'
import ElementPlus from 'element-plus'
import '@/assets/style/element-variables.scss'
import ko from 'element-plus/es/locale/lang/ko'
import common from '@/assets/js/common'
import axios from '@/assets/js/axios'
import VueCountdown from '@chenfengyuan/vue-countdown';

import 'transition-style'
import 'animate.css'

import '@/assets/css/notoSansCJKkr.scss'
import '@/assets/css/nucleo-icons.css'

import '@/assets/css/nucleo-svg.css'
import '@/assets/style/main.css'

import '@/assets/css/soft-ui-dashboard.css?v=1.0.3'
import '@/assets/css/custom.css'

import '@/assets/style/custom-ham.scss'
import '@/assets/style/custom-jo.scss'
import '@/assets/style/custom-xero.scss'
import '@/assets/style/main_ham.scss'

import asideComp from '@/components/asideComp.vue'
import headerComp from '@/components/headerComp.vue'
import footerComp from '@/components/footerComp.vue'

import blur from "@/components/blur";

import lineComp from '@/components/etc/lineComp'

import svgHome from '@/components/svg/svgHome'
import svgMenu from '@/components/svg/svgMenu'

import aceLoading from "@/components/ace-loading";

import storeApi from "@/assets/js/api/store-api";
import configApi from "@/assets/js/api/config-api";
import noticeApi from "@/assets/js/api/notice-api";

globalCookiesConfig({
    expireTimes: '30d',
    path: '/',
    domain: '',
    secure: true,
    sameSite: 'None'
})

const fa = document.createElement('script')
fa.setAttribute('src', 'https://kit.fontawesome.com/42d5adcbca.js')
fa.setAttribute('crossorigin', 'anonymous')
document.head.appendChild(fa)

const app = createApp(App)
.use(i18n).use(common).use(axios).use(store)
.use(router)
.use(storeApi)
.use(configApi)
.use(noticeApi)
.use(ElementPlus, {
    size: 'small',
    zIndex: 3000,
    locale: ko
})

.component(VueCountdown.name, VueCountdown)
.component('asideComp', asideComp)
.component('headerComp', headerComp)
.component('footerComp', footerComp)
.component('aceLoading', aceLoading)

.component('blur', blur)

.component('svgHome', svgHome)
.component('svgMenu', svgMenu)

.component('lineComp', lineComp);

app.mount('#app');

(window).app = app
